import { getCountryList } from '@/core/http/api';

let pending = null;

// Currency options from the country list, shared by every currency selector.
export function loadCurrencyOptions() {
    if (!pending) {
        pending = getCountryList()
            .then(res => (res.data?.data || []).map(c => ({
                value: c.short_form || c.name_en,
                label: c.short_form || c.name_en
            })))
            .catch(() => {
                pending = null;
                return [];
            });
    }
    return pending;
}
